// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"169":"a5f073f6","879":"e14519e4"}[chunkId] + ".chunk.css";
};